import { arrayHelpers } from '@approvalmax/utils';
import { TimeReference } from 'modules/common/ui';
import { domain } from 'modules/data';
import { useCallback } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';

export const useWeekdayOptionSelect = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;

    const handleChange = useCallback(
        (value: domain.DayOfWeek[]) => {
            updateRuleConfig(ruleIndex, {
                daysOfWeek: value,
            });
        },
        [ruleIndex, updateRuleConfig]
    );

    return {
        value: ruleConfig.daysOfWeek || arrayHelpers.emptyArray(),
        handleChange,
    };
};

export const useTimeOptionSelect = (ruleIndex: number) => {
    const { schedule, updateRuleConfig } = useReportSchedulerContext();

    const ruleConfig = schedule.rules[ruleIndex].configuration;

    const handleChange = useCallback(
        (value: string, options: TimeReference[]) => {
            const option = options.find((timeRef) => timeRef.text === value);

            if (option) {
                updateRuleConfig(ruleIndex, {
                    time: {
                        hour: option.hours,
                        minute: option.minutes,
                    },
                });
            }
        },
        [ruleIndex, updateRuleConfig]
    );

    return {
        value: ruleConfig.time,
        handleChange,
    };
};
